var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.classNames,attrs:{"id":"common-wrapper"}},[_c('ModalContainer'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }